import React from 'react';
import { FileText, GitDiff } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

export const CompareModal = ({ open, onOpenChange, history, selectedSessions, onSelect, onCompare }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-lg border-2 border-border max-w-md" data-testid="compare-modal">
      <DialogHeader>
        <DialogTitle className="text-2xl font-medium tracking-tight font-serif">Compare Versions</DialogTitle>
        <DialogDescription className="text-sm text-ash font-sans">Select 2 sessions to compare</DialogDescription>
      </DialogHeader>

      <div className="space-y-2 max-h-96 overflow-y-auto">
        {history.map((item) => {
          const isSelected = selectedSessions.includes(item.session_id);
          return (
            <div
              key={item.session_id}
              onClick={() => onSelect(item.session_id)}
              className={`p-3 border cursor-pointer transition-colors ${
                isSelected ? 'border-gold bg-stone' : 'border-border bg-background hover:bg-stone'
              }`}
              data-testid={`compare-item-${item.session_id}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <FileText size={14} weight="duotone" />
                <span className="text-xs font-medium uppercase text-ivory">{item.document_type}</span>
              </div>
              <p className="text-xs text-bone line-clamp-2">{item.original_text_preview}</p>
            </div>
          );
        })}
      </div>

      <Button
        onClick={onCompare}
        disabled={selectedSessions.length !== 2}
        className="w-full rounded-lg font-medium text-xs uppercase tracking-[0.28em] px-6 py-3 transition-colors duration-200 bg-gold text-charcoal hover:bg-gold-dark disabled:opacity-50"
        data-testid="compare-submit-btn"
      >
        <GitDiff size={16} weight="duotone" className="mr-2" />
        Compare Selected ({selectedSessions.length}/2)
      </Button>
    </DialogContent>
  </Dialog>
);
